import React, { useState } from 'react';
import { serviceService } from '../../Model/Services/serviceService.js';
import { validateImageFile } from '../../Model/Services/imageOptimizationService.js';
import { textToPanelItems } from '../../Model/Services/servicePanelUtils.js';

// NOTE: This component talks directly to serviceService for create/upload.
// Keep this in sync with ServiceViewModel conventions if admin flows are refactored.
function AddService({ onCreated = () => {} }) {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    buttonCTA: '',
    includedIntro: '',
    includedItemsText: '',
    fitsIntro: '',
    fitsItemsText: '',
  });
  const [imageFile, setImageFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const validation = validateImageFile(file);
      if (!validation.valid) {
        setImageFile(null);
        setMessage(validation.reason);
        if (e.target) e.target.value = '';
        return;
      }
    }
    setMessage('');
    setImageFile(file || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      let imageUrl = '';
      if (imageFile) {
        const uploadResult = await serviceService.uploadImage(imageFile);
        imageUrl = uploadResult.publicUrl;
      }

      const { includedItemsText, fitsItemsText, ...rest } = formData;
      const newService = {
        ...rest,
        image: imageUrl,
        includedItems: textToPanelItems(includedItemsText),
        fitsItems: textToPanelItems(fitsItemsText),
      };

      const created = await serviceService.create(newService);
      setMessage('Tjänst tillagd framgångsrikt!');
      setFormData({
        title: '',
        content: '',
        buttonCTA: '',
        includedIntro: '',
        includedItemsText: '',
        fitsIntro: '',
        fitsItemsText: '',
      });
      setImageFile(null);
      if (e.target?.reset) e.target.reset();
      onCreated(created);
    } catch (error) {
      setMessage('Fel vid tillägg av tjänst: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="add-service-grid">
      <form className="admin-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <label>
            Titel
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
            />
          </label>
        </div>

        <label>
          Innehåll
          <textarea
            name="content"
            value={formData.content}
            onChange={handleInputChange}
            required
            rows={4}
          />
        </label>

        <div className="form-grid">
          <label>
            Knapp CTA
            <input
              type="text"
              name="buttonCTA"
              value={formData.buttonCTA}
              onChange={handleInputChange}
              required
            />
          </label>
          <label>
            Bild (valfritt)
              <input
              type="file"
              accept="image/jpeg,image/png,image/webp,image/avif,image/gif"
              onChange={handleFileChange}
            />
          </label>
        </div>

        <p className="eyebrow" style={{ marginTop: '0.75rem' }}>Tjänstesida - paneler (valfritt)</p>
        <label>
          Vad ingår - ingress
          <textarea name="includedIntro" value={formData.includedIntro} onChange={handleInputChange} rows={2} />
        </label>
        <label>
          Vad ingår - en rad per punkt
          <textarea name="includedItemsText" value={formData.includedItemsText} onChange={handleInputChange} rows={4} />
        </label>
        <label>
          När passar tjänsten - ingress
          <textarea name="fitsIntro" value={formData.fitsIntro} onChange={handleInputChange} rows={2} />
        </label>
        <label>
          När passar tjänsten - en rad per punkt
          <textarea name="fitsItemsText" value={formData.fitsItemsText} onChange={handleInputChange} rows={4} />
        </label>

        <div className="form-actions">
          <button className="primary" type="submit" disabled={saving}>
            {saving ? 'Sparar...' : 'Lägg till tjänst'}
          </button>
        </div>
        {message && <p className="admin-message">{message}</p>}
      </form>
    </div>
  );
}

export default AddService;
